module.exports = __webpack_public_path__ + "static/media/connector_icon_azure.cd1cdfe1.svg";